export const RestaurantKind = {
  CAFETERIA: "CAFETERIA",
  RESTAURANT: "RESTAURANT",
  APPROVED_RESTAURANT: "APPROVED_RESTAURANT",
  MANAGED_RESTAURANT: "MANAGED_RESTAURANT",
  ADMINISTRATIVE_RESTAURANT: "ADMINISTRATIVE_RESTAURANT",
  COFFEE_CORNER: "COFFEE_CORNER",
  BREWERY: "BREWERY",
  FOOD_TRUCK: "FOOD_TRUCK",
  SELF_SERVICE: "SELF_SERVICE",
  KIOSK: "KIOSK",
  PIZZERIA: "PIZZERIA",
  GROCERY_STORE: "GROCERY_STORE",
  SCOOTER: "SCOOTER",
  CROUS_AND_GO: "CROUS_AND_GO",
  SANDWICH_SHOP: "SANDWICH_SHOP"
} as const;

export type RestaurantKind = typeof RestaurantKind[keyof typeof RestaurantKind];
